import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListManager } from "react-beautiful-dnd-grid";

import { serviciosReorder, servicioStartDelete } from '../../../actions/servicios';
import { ModalEliminarServicio } from './modales/ModalEliminarServicio';
import { ServicioCard } from './servicios/ServicioCard';
import { DndIcon } from '../../../assets/svg/iconos';

export const Servicios = ({ history, serviciosList, setServiciosList }) => {

    const dispatch = useDispatch();
    const { empresa } = useSelector(state => state.auth);
    const { colores } = useSelector(state => state.ui);
    const wrapper = useRef();
    const [modalEliminarServicioOpened, setModalEliminarServicioOpened] = useState(false);
    const [dataModalEliminar, setDataModalEliminar] = useState({
        title: '¿Eliminar servicio?',
        text: [],
        buttonText: 'Eliminar',
        button2Text: 'Cancelar'
    });

    const [selectedId, setSelectedId] = useState('');
    const [columnas] = useState(5);

    const [activeDnd, setActiveDnd] = useState(false);
    const [dndReady, setDndReady] = useState(false);

    useEffect(() => {
        if (activeDnd) {
            setDndReady(false);
            const applyGridStyles = () => {
                const droppableElements = document.querySelectorAll('.servicios-grid.dnd > div[data-react-beautiful-dnd-droppable]');
                const width = window.innerWidth;
                
                let gridTemplateColumns;
                if (width < 576) {
                    gridTemplateColumns = '1fr';
                } else {
                    gridTemplateColumns = 'repeat(5, 1fr)';
                }
                
                droppableElements.forEach(element => {
                    element.style.setProperty('display', 'grid', 'important');
                    element.style.setProperty('flex-direction', 'unset', 'important');
                    element.style.setProperty('align-items', 'unset', 'important');
                    element.style.setProperty('grid-template-columns', gridTemplateColumns, 'important');
                    element.style.setProperty('width', '100%', 'important');
                    element.style.setProperty('grid-column', '1 / -1', 'important');
                });
                setDndReady(true);
            };
            
            const timeout = setTimeout(applyGridStyles, 10);
            
            const handleResize = () => {
                applyGridStyles();
            };
            window.addEventListener('resize', handleResize);
            
            return () => {
                clearTimeout(timeout);
                window.removeEventListener('resize', handleResize);
            };
        } else {
            setDndReady(false);
        }
    }, [activeDnd, serviciosList]);
    
    const editServicio = ( servicio ) => {
        history.push({
            pathname: `/servicio/${servicio._id}`,
            state: {
                servicio
            }
        });
    };

    const deleteServicioModal = ( servicio ) => {
        setSelectedId( servicio._id );
        setDataModalEliminar({
            ...dataModalEliminar,
            text: [`¿Estás seguro de que deseas eliminar ${servicio.nombre}?`]
        })
        setModalEliminarServicioOpened( true );
    };

    const deleteServicioResponse = ( value ) => {
        if( value === 1 && selectedId !== '' ){
            console.log( 'Borrar id:', selectedId );
            dispatch( servicioStartDelete( selectedId, empresa ) );
        }
    }

    const noop = (oldPos, newPos) => {
        const serviciosVisibles = serviciosList.filter(s => !s.deleted);
        
        if (oldPos === newPos) {
            return;
        }
        
        if (oldPos < 0 || oldPos >= serviciosVisibles.length) {
            return;
        }
        if (newPos < 0 || newPos >= serviciosVisibles.length) {
            return;
        }
        
        const itemMoved = serviciosVisibles[oldPos];
        const reorderedVisible = [...serviciosVisibles];
        reorderedVisible.splice(oldPos, 1);
        reorderedVisible.splice(newPos, 0, itemMoved);
        
        const ordenMap = new Map();
        reorderedVisible.forEach((servicio, index) => {
            ordenMap.set(servicio._id.toString(), index);
        });
        
        const newList = serviciosList.map(servicio => {
            const servicioId = servicio._id.toString();
            if (ordenMap.has(servicioId)) {
                return {
                    ...servicio,
                    orden: ordenMap.get(servicioId)
                };
            }
            return servicio;
        });

        const sortByOrden = (a, b) => {
            const ordenA = a.orden ?? 9999;
            const ordenB = b.orden ?? 9999;
            
            if (ordenA > ordenB) {
                return 1;
            }
            if (ordenA < ordenB) {
                return -1;
            }
            return 0;
        };

        newList.sort(sortByOrden);
        setServiciosList(newList);
        dispatch(serviciosReorder(newList, empresa));
    };

    const toggleDnd = () => {
        setActiveDnd( !activeDnd );
    }

    return (
        <>
        {
            !activeDnd
            &&
            <div 
                className='servicios'
                style={{
                    '--colorPrincipal': colores.colorPrincipal,
                    '--colorSecundario': colores.colorSecundario,
                    '--color3': colores.color3,
                    '--color4': colores.color4,
                    '--color5': colores.color5,
                    '--color6': colores.color6,
                    '--color7': colores.color7,
                }}
            >
                <div className='servicios-grid' ref={wrapper}>
                    {
    
                        serviciosList.map( servicio => (
                            !servicio.deleted &&
                            <ServicioCard
                                key={ servicio._id }
                                servicio={ servicio }
                                editServicio={ editServicio }
                                deleteServicio={ deleteServicioModal }
                            />
                        ))
                    }
                </div>
            </div>
        }
        {
            activeDnd
            &&
            <div className='servicios'>
                <div 
                    className='servicios-grid dnd' 
                    ref={wrapper}
                    style={{ 
                        opacity: dndReady ? 1 : 0,
                        transition: 'opacity 0.15s ease-in-out'
                    }}
                >
                    <ListManager
                        items={serviciosList.filter(s => !s.deleted)}
                        direction="horizontal"
                        maxItems={columnas}
                        render={servicio => 
                            <ServicioCard
                                key={ servicio._id }
                                servicio={ servicio }
                                editServicio={ editServicio }
                                deleteServicio={ deleteServicioModal }
                            />
                        }
                        onDragEnd={noop}
                    />
                </div>
            </div>
        }
        <div 
            className={ `toggle-dnd ${activeDnd ? 'active' : 'unactive'}`}
            onClick={ toggleDnd }
        ><DndIcon color={ activeDnd ? 'white' : colores.colorPrincipal } /><p>Drag & Drop</p></div>

        <ModalEliminarServicio
            data = { dataModalEliminar }
            setModalResponse = { deleteServicioResponse }
            modalOpened = { modalEliminarServicioOpened }
            setModalOpened = { setModalEliminarServicioOpened }
        />
        </>
    )
}
